import { render } from "./LoginCallBack.vue?vue&type=template&id=373ba910"
import script from "./LoginCallBack.vue?vue&type=script&lang=js"
export * from "./LoginCallBack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__